export default __webpack_public_path__ + "static/media/logo_name_blue.2cd1b9ce.svg";